"use client";

import { FC, useState } from "react";
import { ChevronsUpDown } from "lucide-react";

import { Button } from "@/components/ui/button";
import {
  Command,
  CommandEmpty,
  CommandGroup,
  CommandInput,
  CommandItem,
  CommandList,
} from "@/components/ui/command";
import {
  Popover,
  PopoverContent,
  PopoverTrigger,
} from "@/components/ui/popover";
import { FormItem, FormLabel, FormControl, FormMessage } from "./ui/form";
import { ControllerRenderProps } from "react-hook-form";

interface Props {
  options: { label: string; value: string }[];
  label: string;
  placeholder: string;
  field: ControllerRenderProps<any>;
}

const FormComboBox: FC<Props> = ({ options, label, placeholder, field }) => {
  const [open, setOpen] = useState(false);
  const [value, setValue] = useState("");

  return (
    <FormItem className="shadow-none drop-shadow-none">
      <FormLabel className="m-0 p-0 text-[14px] text-[#6F7582]">
        {label}
      </FormLabel>
      <FormControl>
        <Popover open={open} onOpenChange={setOpen}>
          <PopoverTrigger asChild>
            <Button
              variant="outline"
              role="combobox"
              aria-expanded={open}
              className="w-full justify-between text-black text-[12px]"
            >
              {field && field.value
                ? options.find((opt) => opt.value === field.value)?.label
                : placeholder}
              <ChevronsUpDown className="ml-2 h-4 w-4 shrink-0" />
            </Button>
          </PopoverTrigger>
          <PopoverContent className="w-[650px] p-0">
            <Command className="w-full">
              <CommandInput
                placeholder={placeholder}
                className="border border-white m-0 py-2 text-[12px]"
              />
              <CommandList>
                <CommandEmpty>No option found.</CommandEmpty>
                <CommandGroup>
                  {options.map((opt, i) => (
                    <CommandItem
                      key={`${i}`}
                      value={opt.value}
                      onSelect={(currentValue) => {
                        field.onChange(
                          currentValue === value ? "" : currentValue
                        );
                        setOpen(false);
                      }}
                    >
                      {opt.label}
                    </CommandItem>
                  ))}
                </CommandGroup>
              </CommandList>
            </Command>
          </PopoverContent>
        </Popover>
      </FormControl>
      <FormMessage />
    </FormItem>
  );
};

export default FormComboBox;
